import { devices } from './utils';
import constants from './constants';

const {
  i18n: { __ },
  blockEditor: { useSettings },
  components: { PanelBody, SelectControl },
} = wp;

const SpacingBottom = ({ spacingBottom, setAttributes }) => {
  const [spacingValues] = useSettings(`custom.blockSpacingClasses`) || {};
  const onChangeBottomSpacing = (
    paramKey,
    paramValue,
    paramDeviceType,
    paramSpacingBottom,
  ) => {
    setAttributes({
      spacingBottom: {
        ...paramSpacingBottom,
        [paramDeviceType]: {
          ...paramSpacingBottom[paramDeviceType],
          settings: {
            ...paramSpacingBottom[paramDeviceType].settings,
            [paramKey]: paramValue,
          },
        },
      },
    });
  };

  return (
    <PanelBody title={__('Spacing - Bottom', 'b3rg')} initialOpen={false}>
      {devices.map((device, index) => {
        const deviceType = device.type;
        const deviceLabel = device.label;
        const dropdownOptions =
          Object.keys(spacingValues).length !== 0
            ? spacingValues
            : constants.SPACING_VALUES;
        return (
          <PanelBody
            title={deviceLabel}
            initialOpen={index === 0}
            key={deviceType}
          >
            <SelectControl
              label={__('Margin', 'b3rg')}
              options={[
                constants.DEFAULT_OPTION,
                ...dropdownOptions.spacingBottom[deviceType].margin,
              ]}
              value={spacingBottom[deviceType].settings.margin}
              onChange={(value) => {
                onChangeBottomSpacing(
                  'margin',
                  value,
                  deviceType,
                  spacingBottom,
                );
              }}
            />

            <SelectControl
              label={__('Padding', 'b3rg')}
              options={[
                constants.DEFAULT_OPTION,
                ...dropdownOptions.spacingBottom[deviceType].padding,
              ]}
              value={spacingBottom[deviceType].settings.padding}
              onChange={(value) => {
                onChangeBottomSpacing(
                  'padding',
                  value,
                  deviceType,
                  spacingBottom,
                );
              }}
            />
            <p className="components-panel__help-text">{constants.HELP_TEXT}</p>
          </PanelBody>
        );
      })}
    </PanelBody>
  );
};

export default SpacingBottom;
